import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './EligibleCSBNew.style';

interface EligibleCSBNewProps {
  item: {
    newOECount: any;
  };
}
export const EligibleCSBNew = (props: EligibleCSBNewProps) => {
  const {item} = props;

  const newClients = item?.newOECount ?? '0';
  return (
    <View style={styles.row}>
      <Text
        style={styles.textStyle}
        {...testProperties(Reports.reportCoachNewClients)}>
        New: {newClients}
      </Text>
    </View>
  );
};
export default withTranslation('report.record.EligibleCSBNew')(EligibleCSBNew);
